'use client';

import { memo, useCallback } from 'react';
import { Box, MenuItem } from '@mui/material';
import { localeNames, type Locale } from '@/config/i18n/locales';
import {
  FLAG_IMG_SX,
  localeToFlag,
  MENU_ITEM_INNER_SX,
  MENU_ITEM_LABEL_SELECTED_SX,
  MENU_ITEM_LABEL_SX,
  MENU_ITEM_SX,
} from '@/constants';

type LanguageMenuItemProps = {
  locale: Locale;
  selected: boolean;
  onSelect: (locale: Locale) => void;
};

export const LanguageMenuItem = memo(function LanguageMenuItem({
  locale,
  selected,
  onSelect,
}: LanguageMenuItemProps) {
  const handleClick = useCallback(() => onSelect(locale), [locale, onSelect]);
  const flag = localeToFlag[locale];

  return (
    <MenuItem onClick={handleClick} selected={selected} sx={MENU_ITEM_SX}>
      <Box sx={MENU_ITEM_INNER_SX}>
        {flag ? (
          <Box component="img" src={flag.src} alt={localeNames[locale]} sx={FLAG_IMG_SX} />
        ) : null}
        <Box component="span" sx={selected ? MENU_ITEM_LABEL_SELECTED_SX : MENU_ITEM_LABEL_SX}>
          {localeNames[locale]}
        </Box>
      </Box>
    </MenuItem>
  );
});
